<template>
  <div id="listWidget" class="mb-5">
    <!-- <h4 class="mb-3">설정</h4> -->
    <!-- <p>
      영역을 추가해주세요. 아래 <code style="font-size: 100%">영역 버튼</code>을
      누르시면 해당 영역이 추가 됩니다. 추가된 영역의
      <code style="font-size: 100%">상세보기 버튼</code>을 누르시면 방 추가
      화면으로 이동할 수 있습니다.
    </p> -->
    <div class="row">
      <div class="col-xl-6">
        <!-- 기본 설정 -->
        <div class="text-muted fs-12px mb-2"><b>기본 설정</b></div>
        <div class="list-group mb-4">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingZoneClick">
            <div class="flex-fill">
              <div class="fw-600">영역 설정</div>
              <div class="fs-12px text-muted">
                집이나 사무실 등 영역을 설정 할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div>

        <!-- 장치 설정 -->
        <div class="text-muted fs-12px mb-2"><b>장치 설정</b></div>
        <div class="list-group mb-4">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingLightClick" v-if="isOwnerZone">
            <div class="flex-fill">
              <div class="fw-600">조명 설정</div>
              <div class="fs-12px text-muted">
                조명 장치를 추가/삭제 할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          
          <ListGroupItem v-if="isEnabledVoiler && isOwnerZone" class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingTempClick">
            <div class="flex-fill">
              <div class="fw-600">온도 조절기 설정</div>
              <div class="fs-12px text-muted">
                온도 조절기를 추가/삭제 할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem v-if="isEnabledCurtain && isOwnerZone" class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingCurtainClick">
            <div class="flex-fill">
              <div class="fw-600">전동커튼 설정</div>
              <div class="fs-12px text-muted">
                전동커튼, 전동블라인드 장치를 추가/삭제 할 수 있습니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <!-- <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onSettingVirtualSwitchClick">
            <div class="flex-fill">
              <div class="fw-600">가상스위치 설정</div>
              <div class="fs-12px text-muted">
                가상스위치 제어기를 등록/관리 할 수 있습니다.<br>
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem> -->
          <ListGroupItem v-if="isEnabledChangeController" class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onTransferChangeControllerClick">
            <div class="flex-fill">
              <div class="fw-600">컨트롤러 교체</div>
              <div class="fs-12px text-muted">
                이미 설치된 컨트롤러(조명제어기, 온도조절기)를 다른 컨트롤러로 교체합니다.<br>
                <!-- <span class="text-danger">기존에 설치된 조명제어기의 wifi 셋팅 정보를 변경할때만 사용하십시오.</span> -->
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div>

        <!-- 데이터 관리 -->
        <div class="text-muted fs-12px mb-2"><b>데이터 관리</b></div>
        <div class="list-group mb-3">
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onTransferSendClick">
            <div class="flex-fill">
              <div class="fw-600">이관 하기</div>
              <div class="fs-12px text-muted">
                다른 사용자에게 설정 데이터를 이관합니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem class="card-item mb-2" style="border-radius: 1.2rem; border-top: none !important;" @click="onTransferReceiveClick">
            <div class="flex-fill">
              <div class="fw-600">이관 받기</div>
              <div class="fs-12px text-muted">
                이전 사용자의 설정 데이터를 나에게 이관합니다.
              </div>
            </div>
            <div>
              <div class="form-switch h-100">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div>
          <!-- <ListGroupItem style="border-radius: 1.2rem;" @click="onInitZoneClick">
            <div class="flex-fill">
              <div class="fw-600">초기화</div>
              <div class="fs-12px text-muted">
                영역에 포함된 모든 정보를 초기화합니다.
              </div>
            </div>
            <div>
              <div class="form-switch h-100">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem> -->

        <!-- <div class="text-muted fs-12px mb-2"><b>컨트롤러</b></div>
        <div class="list-group" style="border-radius: 1.2rem">
          <ListGroupItem style="border-radius: 1.2rem; margin-bottom: 4px;" @click="onTransferRegistClick">
            <div class="flex-fill">
              <div class="fw-600">최초 등록</div>
              <div class="fs-12px text-muted">
                사업자 또는 시공자가 시스템을 설치할 때 최초로 장치등을
                등록합니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
          <ListGroupItem style="border-radius: 1.2rem; margin-bottom: 4px;" @click="onTransferChangeClick">
            <div class="flex-fill">
              <div class="fw-600">와이파이 변경</div>
              <div class="fs-12px text-muted">
                설치된 지역의 Wifi가 변경되었을 때 변경된 wifi 정보를
                컨트롤러에 재설정 합니다.
              </div>
            </div>
            <div>
              <div class="form-switch">
                <i class="fa fa-chevron-right"></i>
              </div>
            </div>
          </ListGroupItem>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';
import { useStore } from 'vuex';
import {
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  computed,  
} from 'vue';
const { emitter, mobile, logger } =
  getCurrentInstance().appContext.config.globalProperties;
const router = useRouter();
const store = useStore();

const isOwnerZone = computed(() => {
  if (!store.getters['home/getCurrentZone']) {
    return true;
  }
  return store.getters['home/getCurrentZone']?.ownerId != undefined 
    && store.getters['account']?._id != undefined 
    && store.getters['home/getCurrentZone']?.ownerId === store.getters['account']?._id;
});

const onSettingZoneClick = () => router.push('/settings/zones');
const onSettingLightClick = () => router.push('/settings/light');
const onSettingTempClick = () => router.push('/settings/temp');
const onSettingCurtainClick = () => router.push('/settings/curtain');
const onTransferSendClick = () => router.push('/settings/send');
const onTransferReceiveClick = () => router.push('/settings/receive');
const onSettingVirtualSwitchClick = () => router.push('/setting/virtual');
const onTransferChangeControllerClick = () => router.push('/settings/select/controller');
const onInitZoneClick = () => router.push('/settings/init');

const isEnabledVoiler = process.env.VUE_APP_ENABLE_TEMP_CONTROLLER === 'true' || false;
const isEnabledCurtain = process.env.VUE_APP_ENABLE_TEMP_CONTROLLER === 'true' || false;
const isEnabledChangeController = process.env.VUE_APP_ENABLE_TEMP_CONTROLLER === 'true' || false;

console.log(`process.env.VUE_APP_ENABLE_TEMP_CONTROLLER  : `,process.env.VUE_APP_ENABLE_TEMP_CONTROLLER )


onBeforeMount(() => {  
  emitter.emit('onChangeHeaderSetting',{title:'설정',isShowMenu:false,isShowZone:false,isShowProfile:false});    
});
onBeforeUnmount(() =>{
  emitter.emit('onChangeHeaderSetting',{title:'',isShowMenu:true,isShowZone:true,isShowProfile:true});  
})
</script>

<!-- <script>
export default {
	data() {
		return {
			isEnabledVoiler: process.env.VUE_APP_ENABLE_TEMP_CONTROLLER === 'true', // Ensure it's a boolean
      isEnabledCurtain: process.env.VUE_APP_ENABLE_TEMP_CONTROLLER === 'true', // Ensure it's a boolean
		}
	}
}
</script> -->
